module.exports = __webpack_public_path__ + "img/start3.dad96b98.svg";